export function getFormFieldSelectValue(item) {
  return item?.value
}

export function getFormFieldSelectLabel(item) {
  return item?.label
}
